module.exports = __webpack_public_path__ + "static/media/carrot.ccc9b379.svg";